import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://backend.buildsupplyco.com/api/v1';

export interface WishlistItemResponse {
  productId: string;
  variantSku?: string;
  variantId?: string;
  product?: any;
  variantInfo?: any;
}

export interface WishlistApiResponse {
  success: boolean;
  data?: WishlistItemResponse[];
  message?: string;
}

export class WishlistApiService {
  private getHeaders() {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    };
  }

  async getWishlist(): Promise<WishlistApiResponse> {
    try {
      const response = await axios.get<WishlistApiResponse>(`${API_BASE_URL}/wishlist`, {
        headers: this.getHeaders()
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async addToWishlist(payload: any): Promise<WishlistApiResponse> {
    try {
      const response = await axios.post<WishlistApiResponse>(`${API_BASE_URL}/wishlist`, payload, {
        headers: this.getHeaders()
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async removeFromWishlist(productId: string, variantSku?: string): Promise<WishlistApiResponse> {
    try {
      const url = `${API_BASE_URL}/wishlist/${productId}${variantSku ? `?variantSku=${encodeURIComponent(variantSku)}` : ''}`;
      const response = await axios.delete<WishlistApiResponse>(url, {
        headers: this.getHeaders()
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async clearWishlist(): Promise<WishlistApiResponse> {
    try {
      const response = await axios.delete<WishlistApiResponse>(`${API_BASE_URL}/wishlist/empty`, {
        headers: this.getHeaders()
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async mergeWishlist(guestItems: any[]): Promise<WishlistApiResponse> {
    try {
      const response = await axios.post<WishlistApiResponse>(
        `${API_BASE_URL}/wishlist/merge`,
        { items: guestItems },
        { headers: this.getHeaders() }
      );
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }
}

export const wishlistApiService = new WishlistApiService();
